"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OktonMultiSelectModal = exports.OktonSearchInput = void 0;
__exportStar(require("./OktonSearchSelect"), exports);
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
const lu_1 = require("react-icons/lu");
const OktonSearchInput = ({ value, onChange, placeholder = 'Buscar', isDisabled, onEnter, }) => (react_2.default.createElement(react_1.InputGroup, null,
    react_2.default.createElement(react_1.InputLeftElement, { pointerEvents: "none" }, react_2.default.createElement(lu_1.LuSearch)),
    react_2.default.createElement(react_1.Input, { value: value, placeholder: placeholder, isDisabled: isDisabled, rounded: "xl", onChange: event => onChange(event.target.value), onKeyDown: event => {
            if (event.key === 'Enter')
                onEnter === null || onEnter === void 0 ? void 0 : onEnter();
        } })));
exports.OktonSearchInput = OktonSearchInput;
function OktonMultiSelectModal({ isOpen, onClose, title = 'Selecionar registros', selected, onChange, onConfirm, getValue, getLabel, getDescription, items = [], loadOptions, placeholder = 'Buscar', confirmLabel = 'Confirmar', }) {
    const [search, setSearch] = react_2.default.useState('');
    const [page, setPage] = react_2.default.useState(1);
    const [remoteItems, setRemoteItems] = react_2.default.useState([]);
    const [hasMore, setHasMore] = react_2.default.useState(false);
    const [loading, setLoading] = react_2.default.useState(false);
    const [error, setError] = react_2.default.useState('');
    const bg = (0, react_1.useColorModeValue)('white', 'gray.800');
    const borderColor = (0, react_1.useColorModeValue)('gray.200', 'gray.700');
    react_2.default.useEffect(() => {
        if (!isOpen || !loadOptions)
            return;
        let active = true;
        setLoading(true);
        setError('');
        const timer = window.setTimeout(() => {
            loadOptions(search, page)
                .then(result => {
                if (!active)
                    return;
                setRemoteItems(result.items);
                setHasMore(result.hasMore);
                setLoading(false);
            })
                .catch(err => {
                if (!active)
                    return;
                setError(err instanceof Error
                    ? err.message
                    : 'Não foi possível carregar os registros.');
                setLoading(false);
            });
        }, 250);
        return () => {
            active = false;
            window.clearTimeout(timer);
        };
    }, [isOpen, loadOptions, search, page]);
    react_2.default.useEffect(() => {
        if (!isOpen) {
            setSearch('');
            setPage(1);
            setRemoteItems([]);
            setHasMore(false);
            setError('');
        }
    }, [isOpen]);
    const visibleItems = react_2.default.useMemo(() => {
        if (loadOptions)
            return remoteItems;
        const term = search.trim().toLocaleLowerCase('pt-BR');
        if (!term)
            return items;
        return items.filter(item => String(getLabel(item))
            .toLocaleLowerCase('pt-BR')
            .includes(term));
    }, [loadOptions, remoteItems, items, search, getLabel]);
    const selectedKeys = react_2.default.useMemo(() => new Set(selected.map(item => String(getValue(item)))), [selected, getValue]);
    const allVisibleSelected = visibleItems.length > 0 &&
        visibleItems.every(item => selectedKeys.has(String(getValue(item))));
    function toggle(item) {
        const key = String(getValue(item));
        if (selectedKeys.has(key)) {
            onChange(selected.filter(current => String(getValue(current)) !== key));
        }
        else {
            onChange([...selected, item]);
        }
    }
    function toggleAllVisible() {
        if (allVisibleSelected) {
            const visibleKeys = new Set(visibleItems.map(item => String(getValue(item))));
            onChange(selected.filter(item => !visibleKeys.has(String(getValue(item)))));
            return;
        }
        const next = [...selected];
        const keys = new Set(selectedKeys);
        visibleItems.forEach(item => {
            const key = String(getValue(item));
            if (!keys.has(key)) {
                next.push(item);
                keys.add(key);
            }
        });
        onChange(next);
    }
    return (react_2.default.createElement(react_1.Modal, { isOpen: isOpen, onClose: onClose, size: "4xl", scrollBehavior: "inside" },
        react_2.default.createElement(react_1.ModalOverlay, null),
        react_2.default.createElement(react_1.ModalContent, { bg: bg, rounded: "xl" },
            react_2.default.createElement(react_1.ModalHeader, null, title),
            react_2.default.createElement(react_1.ModalCloseButton, null),
            react_2.default.createElement(react_1.ModalBody, null,
                react_2.default.createElement(exports.OktonSearchInput, { value: search, onChange: value => {
                        setSearch(value);
                        setPage(1);
                    }, placeholder: placeholder }),
                react_2.default.createElement(react_1.Flex, { mt: "4", mb: "3", gap: "3", align: "center", wrap: "wrap" },
                    react_2.default.createElement(react_1.Button, { size: "sm", variant: "outline", isDisabled: loading || visibleItems.length === 0, onClick: toggleAllVisible }, allVisibleSelected ? 'Desmarcar todos' : 'Marcar todos'),
                    react_2.default.createElement(react_1.Text, { fontSize: "sm", color: "gray.500" },
                        selected.length,
                        " selecionado",
                        selected.length === 1 ? '' : 's')),
                react_2.default.createElement(react_1.Box, { borderWidth: "1px", borderColor: borderColor, rounded: "lg", minH: "240px", maxH: "420px", overflowY: "auto" }, loading ? (react_2.default.createElement(react_1.Flex, { minH: "240px", align: "center", justify: "center" },
                    react_2.default.createElement(react_1.Spinner, null))) : error ? (react_2.default.createElement(react_1.Flex, { minH: "240px", align: "center", justify: "center", p: "6" },
                    react_2.default.createElement(react_1.Text, { color: "red.500" }, error))) : visibleItems.length === 0 ? (react_2.default.createElement(react_1.Flex, { minH: "240px", align: "center", justify: "center" },
                    react_2.default.createElement(react_1.Text, { color: "gray.500" }, "Nenhum registro encontrado."))) : (react_2.default.createElement(react_1.Stack, { spacing: "0" }, visibleItems.map(item => {
                    const key = String(getValue(item));
                    return (react_2.default.createElement(react_1.Flex, { key: key, px: "4", py: "3", align: "center", gap: "3", borderBottomWidth: "1px", borderColor: borderColor, cursor: "pointer", onClick: () => toggle(item) },
                        react_2.default.createElement(react_1.Checkbox, { isChecked: selectedKeys.has(key), pointerEvents: "none" }),
                        react_2.default.createElement(react_1.Box, { minW: 0 },
                            react_2.default.createElement(react_1.Text, { fontWeight: "600" }, getLabel(item)),
                            getDescription ? (react_2.default.createElement(react_1.Text, { fontSize: "sm", color: "gray.500" }, getDescription(item))) : null)));
                })))),
                loadOptions ? (react_2.default.createElement(react_1.Flex, { mt: "4", justify: "space-between", align: "center" },
                    react_2.default.createElement(react_1.Button, { size: "sm", variant: "outline", isDisabled: page <= 1 || loading, onClick: () => setPage(value => Math.max(1, value - 1)) }, "Anterior"),
                    react_2.default.createElement(react_1.Text, { fontSize: "sm" },
                        "P\u00E1gina ",
                        page),
                    react_2.default.createElement(react_1.Button, { size: "sm", variant: "outline", isDisabled: !hasMore || loading, onClick: () => setPage(value => value + 1) }, "Pr\u00F3xima"))) : null),
            react_2.default.createElement(react_1.ModalFooter, null,
                react_2.default.createElement(react_1.Button, { variant: "ghost", mr: "3", onClick: onClose }, "Cancelar"),
                react_2.default.createElement(react_1.Button, { colorScheme: "blue", onClick: () => {
                        onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm();
                        onClose();
                    } }, confirmLabel)))));
}
exports.OktonMultiSelectModal = OktonMultiSelectModal;
//# sourceMappingURL=index.js.map